import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-java-web-dev',
  templateUrl: './java-web-dev.component.html',
  styleUrls: ['./java-web-dev.component.css']
})
export class JavaWebDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/java-web-dev/java-web-dev.component.ts